interface ExtractedFile {
  name: string;
  fieldName: string;
}

export function extractUploadedFiles(data: unknown): ExtractedFile[] {
  const result: ExtractedFile[] = [];
  const visit = (value: unknown, fieldName?: string) => {
    if (value === null) return;
    // Array
    if (Array.isArray(value)) {
      value.forEach(item => visit(item, fieldName));
      return;
    }

    // Object
    if (typeof value === 'object') {
      const obj = value as Record<string, any>;

      // File object
      if ('url' in obj && 'extension' in obj && typeof obj.name === 'string') {
        result.push({
          fieldName: fieldName ?? '',
          name: obj.name
        });
      }

      // Continue traversing
      Object.entries(obj).forEach(([key, val]) => {
        // Root keys become field names
        //skip validate in previousValue
        if (key !== 'previousValue') {
          const nextFieldName = fieldName ?? key;
          visit(val, nextFieldName);
        }
      });
    }
  };

  visit(data);

  return result;
}
